const compareOrder = (a, b) =>
  parseInt(a && a.order, 10) - parseInt(b && b.order, 10);

export const sortProcessStatuses = (statuses = []) =>
  [...statuses]
    .map((status) => ({
      ...status,
      possibleStatuses: [...(status.possibleStatuses || [])].sort(compareOrder),
    }))
    .sort(compareOrder);

const serializeCondition = (condition) => ({
  id: condition.id,
  operation: condition.operation,
  leftOperand: condition.leftOperand,
  rightOperand: condition.rightOperand,
});

const serializePossibleStatus = (possibleStatus) => ({
  id: possibleStatus.id,
  nextStatus: possibleStatus.nextStatus,
  order: possibleStatus.order,
  kind: possibleStatus.kind,
  event: possibleStatus.event,
  delaySeconds: possibleStatus.delaySeconds,
  conditions: (possibleStatus.conditions || []).map(serializeCondition),
});

const serializeAction = (action) => ({
  id: action.id,
  type: action.type,
  args: action.args,
  conditions: (action.conditions || []).map(serializeCondition),
});

/** Strip read-only GraphQL fields (e.g. screens.versions) before updateProcess. */
export const serializeProcessStatusesForMutation = (statuses = []) =>
  sortProcessStatuses(statuses).map((status) => ({
    id: status.id,
    name: status.name,
    tag: status.tag,
    color: status.color,
    background: status.background,
    progress: status.progress,
    order: status.order,
    template: status.template,
    binding: status.binding,
    nodeType: status.nodeType,
    config: status.config,
    formDefinition: status.formDefinition,
    position: status.position,
    entryConnectors: status.entryConnectors,
    outputConnectors: status.outputConnectors,
    dataBindings: status.dataBindings,
    moveToNext: status.moveToNext,
    possibleStatuses: (status.possibleStatuses || []).map(
      serializePossibleStatus,
    ),
    actions: (status.actions || []).map(serializeAction),
  }));
